import NavBar from "../components/navbar"
import Title from "../components/marketplace_page/title"
import Featured from "../components/marketplace_page/featured"
import Upcoming from "../components/marketplace_page/upcoming"
import Later from "../components/marketplace_page/later"
import Footer from "../components/footer"

import { Helmet } from 'react-helmet';

export default function Marketplace({principal,setPrincipal}){
    return(
        <>
            <Helmet>
                <title>Marketplace</title>
            </Helmet>
            <div>
                <NavBar principal={principal} setPrincipal={setPrincipal}></NavBar>
                <Title></Title>
                <Featured></Featured>
                <Upcoming></Upcoming>
                <Later></Later>
                <Footer></Footer>
            </div>
        </>
    )
}